import React, { useState } from 'react';
import { Close } from '../icons/Close';
import ErrorPopupLayout from '../layouts/ErrorPopupLayout';
const SectionTitle = ({ title, titleSuffix, rightText, sizeGuideContent, modalButton, customClass, }) => {
    const [openSizeGuide, setOpenSizeGuide] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `hg-modal__title ${customClass ? customClass : ''}` },
            React.createElement("h4", null,
                title,
                titleSuffix && React.createElement("span", null, titleSuffix)),
            modalButton ? (React.createElement("button", { onClick: () => {
                    setOpenSizeGuide(true);
                } }, modalButton)) : null,
            rightText && React.createElement("span", null, rightText)),
        sizeGuideContent && openSizeGuide && (React.createElement(ErrorPopupLayout, null,
            React.createElement("button", { className: "hg-modal__warning--close", "aria-label": "close", onClick: () => {
                    setOpenSizeGuide(false);
                } },
                React.createElement(Close, null)),
            React.createElement("div", { className: "hg-modal__page-content", dangerouslySetInnerHTML: { __html: sizeGuideContent } })))));
};
export default SectionTitle;
